import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/akkuzeylogo.png";
import { useTranslation } from "react-i18next";
import { markaYolu } from "../data/markalar";
import { GOOGLE_HARITA_URL } from "../data/isletme";
import CalismaRozeti from "./CalismaRozeti";

const TELEFON = "+90 537 798 11 29";
const WHATSAPP = "905377981129";
const EPOSTA = "akkuzey@hotmail.com";
const INSTAGRAM_URL = "https://www.instagram.com/akkuzeyinsaat/";

const YOL_TARIFI =
  "https://www.google.com/maps/dir/?api=1&destination=" +
  encodeURIComponent("Akkuzey Yapı Malzemeleri, Çırpıcı 75/2 Sk. No:109, Zeytinburnu, İstanbul");

// Footer'da öne çıkan markalar (hepsi değil); "marka" alanıyla birebir aynı yazılmalı.
const KATALOG_MARKALARI = [
  "Marshall",
  "Filli Boya",
  "Polisan",
  "Kalekim",
  "VitrA",
  "ECA",
  "Creavit",
  "İzeltaş",
  "SGS",
  "Atlas",
  "Kalde",
  "Dekor",
];

const Ikon = ({ ad, className = "h-4 w-4" }) => {
  const ortak = {
    viewBox: "0 0 24 24",
    className,
    "aria-hidden": true,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  switch (ad) {
    case "telefon":
      return (
        <svg {...ortak}>
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.18 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.1 9.9a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      );
    case "eposta":
      return (
        <svg {...ortak}>
          <rect x="2" y="4" width="20" height="16" rx="2" />
          <path d="m22 7-10 6L2 7" />
        </svg>
      );
    case "konum":
      return (
        <svg {...ortak}>
          <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      );
    case "saat":
      return (
        <svg {...ortak}>
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      );
    case "instagram":
      return (
        <svg {...ortak}>
          <rect x="2" y="2" width="20" height="20" rx="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
        </svg>
      );
    case "google":
      return (
        <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
          <path fill="#4285F4" d="M22.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.3h5.9a5.05 5.05 0 0 1-2.19 3.31v2.75h3.54c2.08-1.91 3.25-4.73 3.25-8.09z" />
          <path fill="#34A853" d="M12 23c2.95 0 5.43-.98 7.24-2.64l-3.54-2.75c-.98.66-2.23 1.06-3.7 1.06-2.85 0-5.26-1.92-6.12-4.5H2.22v2.84A10.99 10.99 0 0 0 12 23z" />
          <path fill="#FBBC05" d="M5.88 14.17A6.6 6.6 0 0 1 5.53 12c0-.75.13-1.48.35-2.17V6.99H2.22A10.99 10.99 0 0 0 1 12c0 1.77.43 3.45 1.22 4.94l3.66-2.77z" />
          <path fill="#EA4335" d="M12 5.38c1.61 0 3.05.55 4.19 1.64l3.14-3.14C17.42 2.1 14.95 1 12 1 7.7 1 3.99 3.47 2.22 6.99l3.66 2.84C6.74 7.3 9.15 5.38 12 5.38z" />
        </svg>
      );
    case "whatsapp":
      return (
        <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="currentColor">
          <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.76-1.66-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.56.93.95-3.47-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.23-9.43 9.44-9.43a9.37 9.37 0 0 1 9.42 9.44c0 5.2-4.23 9.43-9.44 9.43zm8.03-17.46A11.3 11.3 0 0 0 12.04.72C5.8.72.72 5.8.72 12.04c0 2 .52 3.94 1.51 5.65L.63 23.28l5.72-1.5a11.3 11.3 0 0 0 5.69 1.45c6.24 0 11.32-5.08 11.32-11.32 0-3.02-1.18-5.87-3.3-8z" />
        </svg>
      );
    default:
      return null;
  }
};

const Footer = () => {
  const { t } = useTranslation();

  const kurumsalLinks = [
    { to: "/about", label: t("footer.corporate.about") },
    { to: "/iletisim", label: t("footer.corporate.contact") },
    {
      to: "/kurumsal/kalite-politikamiz",
      label: t("subMenus.corporate.qualityPolicy"),
    },
    { to: "/sss", label: t("footer.corporate.faq") },
  ];

  const hizliMenuLinks = [
    { to: "/", label: t("homeNavbar") },
    { to: "/urunler", label: t("products") },
    { to: "/markalar", label: t("brandPage.indexTitle") },
    { to: "/hesaplayicilar", label: t("calc.navbarItem") },
    { to: "/toptan-teklif", label: t("quote.title") },
    { to: "/rehber", label: t("guide.title") },
    { to: "/stores", label: t("storesFooter") },
    { to: "/bayilikler", label: t("dealerships") },
  ];

  const sosyal = [
    {
      ad: "instagram",
      href: INSTAGRAM_URL,
      label: t("footer.social.instagram"),
      renk: "bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF]",
    },
    {
      ad: "google",
      href: GOOGLE_HARITA_URL,
      label: t("reviews.footerLabel"),
      renk: "bg-white ring-1 ring-line",
    },
    {
      ad: "whatsapp",
      href: `https://wa.me/${WHATSAPP}`,
      label: t("footer.social.whatsapp"),
      renk: "bg-[#25D366]",
    },
  ];

  const iletisim = [
    {
      ikon: "telefon",
      icerik: TELEFON,
      href: `tel:${TELEFON.replace(/\s/g, "")}`,
      ltr: true,
    },
    { ikon: "eposta", icerik: EPOSTA, href: `mailto:${EPOSTA}`, ltr: true },
    {
      ikon: "konum",
      icerik: (
        <>
          {t("footer.contactInfo.address")}
          <span className="mt-1 block text-[12.5px] font-medium text-accent">
            {t("footer.contactInfo.directions")} →
          </span>
        </>
      ),
      href: YOL_TARIFI,
      disarida: true,
    },
    {
      ikon: "saat",
      icerik: (
        <>
          {t("footer.contactInfo.weekdays")}
          <span className="block">{t("footer.contactInfo.sunday")}</span>
          <span className="mt-1.5 block"><CalismaRozeti /></span>
        </>
      ),
    },
  ];

  return (
    <footer className="border-t border-line bg-canvas">
      {/* Katalogdaki markalar */}
      <div className="border-b border-line">
        <div className="container-page py-10">
          <div className="flex flex-wrap items-end justify-between gap-2">
            <h2 className="eyebrow">{t("footer.brandsStrip.title")}</h2>
            <p className="text-[13px] text-muted">{t("footer.brandsStrip.subtitle")}</p>
          </div>

          <ul className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {KATALOG_MARKALARI.map((marka) => (
              <li key={marka}>
                <Link
                  to={markaYolu(marka)}
                  className="group flex h-14 items-center justify-center rounded-lg border border-line bg-white px-3 text-[13.5px] font-semibold tracking-[0.08em] text-body transition-all duration-200 hover:-translate-y-0.5 hover:border-ink/25 hover:text-ink hover:shadow-sm"
                >
                  {/* tr kuralı "Fit"i "FİT" yapardı; standart çeviri İzeltaş'ı da doğru verir */}
                  {marka.toLocaleUpperCase("tr")}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container-page grid grid-cols-1 gap-10 py-14 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
        {/* Marka */}
        <div className="lg:col-span-3">
          <img src={logo} alt={t("ui.logoAlt")} className="h-16 w-auto" />
          <p className="mt-5 max-w-sm text-[14px] leading-relaxed text-muted">
            {t("footer.description")}
          </p>

          <div className="mt-6 flex items-center gap-3">
            {sosyal.map((s) => {
              const sinif = `inline-flex h-11 w-11 items-center justify-center rounded-full text-white shadow-sm transition-all duration-200 ${s.renk}`;
              return s.href ? (
                <a
                  key={s.ad}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  className={`${sinif} hover:-translate-y-0.5 hover:shadow-md`}
                >
                  <Ikon ad={s.ad} className="h-5 w-5" />
                </a>
              ) : (
                <span key={s.ad} title={s.label} className={sinif}>
                  <Ikon ad={s.ad} className="h-5 w-5" />
                </span>
              );
            })}
          </div>
        </div>

        {/* Bağlantılar */}
        <div className="grid grid-cols-2 gap-8 lg:col-span-3">
          <div>
            <h3 className="eyebrow mb-4">{t("footer.corporate.title")}</h3>
            <ul className="space-y-2.5 text-[14px]">
              {kurumsalLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="link-muted">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="eyebrow mb-4">{t("footer.quickMenu.title")}</h3>
            <ul className="space-y-2.5 text-[14px]">
              {hizliMenuLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="link-muted">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* İletişim */}
        <div className="lg:col-span-3">
          <h3 className="eyebrow mb-4">{t("footer.contactInfo.title")}</h3>
          <ul className="space-y-3.5 text-[14px] leading-snug text-body">
            {iletisim.map((satir) => {
              const icerik = (
                <>
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line bg-white text-accent">
                    <Ikon ad={satir.ikon} className="h-3.5 w-3.5" />
                  </span>
                  <span dir={satir.ltr ? "ltr" : undefined} className="pt-1">
                    {satir.icerik}
                  </span>
                </>
              );
              return (
                <li key={satir.ikon}>
                  {satir.href ? (
                    <a
                      href={satir.href}
                      {...(satir.disarida
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {})}
                      className="flex gap-3 transition-colors hover:text-ink"
                    >
                      {icerik}
                    </a>
                  ) : (
                    <div className="flex gap-3">{icerik}</div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        {/* Harita */}
        <div className="lg:col-span-3">
          <h3 className="eyebrow mb-4">{t("footer.map.title")}</h3>
          <iframe
            title="Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4258.4851743629415!2d28.901669644595476!3d40.998913533322686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cabb0b9c5edba1%3A0x9b51e9e74440aff8!2sAkkuzey%20yap%C4%B1%20malzemeleri%20adem%20akkuzey%20-%20Marshall%20boya%20sat%C4%B1%C5%9F%20noktas%C4%B1!5e0!3m2!1str!2str!4v1765472040154!5m2!1str!2str"
            width="100%"
            height="220"
            allowFullScreen=""
            loading="lazy"
            className="rounded-lg border border-line grayscale-[35%]"
          ></iframe>
        </div>
      </div>

      {/* Alt Telif */}
      <div className="border-t border-line">
        {/* sabit WhatsApp butonu imzanın üstüne binmesin: mobilde alttan, geniş ekranda sağdan boşluk */}
        <div className="container-page flex flex-col items-center justify-between gap-3 pb-24 pt-6 text-[12.5px] text-muted sm:flex-row sm:pb-6 sm:pr-24 xl:pr-8">
          <p className="text-center sm:text-left">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>

          <p
            dir="ltr"
            className="group inline-flex items-center gap-2 rounded-full border border-line bg-white px-3.5 py-1.5 text-[11.5px] tracking-wide transition-colors hover:border-ink/25"
          >
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              className="h-3.5 w-3.5 text-accent transition-transform duration-300 group-hover:rotate-[-8deg]"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="16 18 22 12 16 6" />
              <polyline points="8 6 2 12 8 18" />
            </svg>
            <span>Designed &amp; Developed by</span>
            <span className="font-semibold tracking-[0.12em] text-ink">
              EFE AKKUZEY
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
